<template>
<div class="vliveContentImages">
    <div class="image-list">
        <img v-lazy="image.coveratturl" alt="" v-for="(image, index) in imageList" :key="index">
        <!--<span @click="loadMore" v-if="page.page < totalPage">加载更多</span>-->
        <div class="upload cover-image" @click="loadMore" v-if="page.page < totalPage">
            <div class="avatar-uploader">
                <div class="el-upload el-upload--text">
                    <i class="el-icon-plus avatar-uploader-icon icon_upload"></i>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {findGroupImage} from 'api/materialMgtApi'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'vliveContentImages',
    data() {
        return {
            imageList: [],
            totalPage: 0,
            page: {
                page: 1,
                pageSize: 20
            },
            param: {
                catalogInnerId: '', // 图片分类的innerid
                hostinfoinnerid: '' // 主办方innerid
            }
        }
    },
    mounted() {
        this.param.hostinfoinnerid = this.user.hostinnerid
    },
    methods: {
        loadMore() {
            this.page.page++
            this._getList()
        },
        _getGroupImage(relinnerid) {
            this.param.catalogInnerId = relinnerid
            this._getList()
        },
        // 获取图片合集
        _getList() {
            this.setLoading(true)
            findGroupImage({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.imageList = this.imageList.concat(data.data)
                    this.totalPage = data.pageableData.pageCount
                    this.vliveModel.contentList.forEach(obj => {
                        if (obj.columntype === 3) {
                            obj.imageList = this.imageList
                        }
                    })
                    this.setVliveModelContentList(this.vliveModel.contentList)
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setVliveModelContentList',
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'vliveModel',
            'user'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.vliveContentImages {
    .image-list{
        @include flexBox(flex-start);
        flex-wrap: wrap;
        img{
            width: 120px;
            height: 120px;
            margin:0 20px 20px 0;
        }
        .cover-image{
            display: inline-block;
            margin:0 20px 20px 0;
            .icon, .avatar-uploader{
                box-sizing: border-box;
                height: 120px;
                width: 120px;
            }
        }
    }
}
</style>
